import axios from "axios";

// const property = `354363998`;
const baseUrl = `https://analyticsdata.googleapis.com/v1beta/properties`;

const oAuthPlayground = async (param) => {
  try {
    const res = await axios.get(
      `https://developers.google.com//oauthplayground/?code=4/0AfJohXkYBX-_Q2q7cS4K55dCSmQmHR1r0yk08TXvR1XZdz5Om2JeSKlut2RS2Q4AN4EglQ&scope=https://www.googleapis.com/auth/analytics%20https://www.googleapis.com/auth/analytics.readonly`,
    );
    return res;
  } catch (e) {
    console.log("oAuthPlayground", e);
  }
};
const googleOauth = async (param) => {
  try {
    const response = await axios.get(
      // "https://accounts.google.com/o/oauth2/token",
      "https://www.googleapis.com/auth/analytics.readonly",
      { params: param },
    );
    return response;
  } catch (e) {
    console.log("googleOauth", e);
  }
};

/**
 * 구글 애널리틱스 가져오기
 * @param param
 * @param param.dimensions required
 * @param param.metrics required
 * @param param.dateRanges
 * @returns {Promise<AxiosResponse<*>>}
 *
 * {
 * 		"dimensions":[{"name":"dateHour"}],
 *	 	"metrics":[{"name":"active1DayUsers"},{"name":"activeUsers"},{"name":"sessions"}],
 * 		"dateRanges":[{"startDate":"yesterday","endDate":"today"}]
 * 	}
 */
const runGAReport = async (param, headers) => {
  try {
    // const api_key = `AIzaSyA09Ii-iTpRtaX3KTiznDJUsTgh3dEUvLM`;
    const response = await axios.post(
      `${baseUrl}/${process.env.REACT_APP_GA_PROPERTY}:runReport`,
      // `${baseUrl}:runReport?key=${api_key}`,
      param,
      {
        headers: headers,
      },
    );
    return response;
  } catch (e) {
    console.log("GAReport", e);
  }
};
const runRealTimeGAReport = async (param, headers) => {
  try {
    // const api_key = `AIzaSyA09Ii-iTpRtaX3KTiznDJUsTgh3dEUvLM`;
    const response = await axios.post(
      `${baseUrl}/${process.env.REACT_APP_GA_PROPERTY}:runRealtimeReport`,
      // `${baseUrl}:runReport?key=${api_key}`,
      param,
      {
        headers: headers,
      },
    );
    return response;
  } catch (e) {
    console.log("runRealTimeGAReport", e);
  }
};

const googleApi = {
  oAuthPlayground,
  googleOauth,
  runGAReport,
  runRealTimeGAReport,
};

export default googleApi;
